import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_STRING } from '../../../../constants/common'
import { useInitData } from '../../../../hooks'
import { AITextGenerationType } from '../../../AITextGeneration'
import {
  AITextGenerationField,
  applyAITextToTextareaField,
} from '../../../AITextGenerationField'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../Form'
import { FormikField } from '../../../Formik'
import { MessageTemplateSelect } from '../../../MessageTemplate'
import { TextareaOutlineField } from '../../../Textarea'

import { setTextTemplate } from './RequestEditUserCommentFields.api'
import {
  REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT,
  REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE,
  REQUEST_EDIT_USER_COMMENT_FIELDS_TEMPLATES_PARAMS,
} from './RequestEditUserCommentFields.constants'

import * as styles from './RequestEditUserCommentFields.module.css'

function RequestEditUserCommentFields({
  aiLocalContext,
  commentFieldName = REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT,
  containerClassName,
  id,
  textareaClassName = styles.textarea,
  onClick,
}) {
  const { t } = useTranslation()

  const { setFieldValue, values } = useFormikContext()

  const { ai_features: aiFeatures } = useInitData()

  function handleChangeTemplate(item) {
    if (item) {
      setTextTemplate(item.value, {
        request_id: id,
      }).then(data => {
        setFieldValue(commentFieldName, data.data.text)
      })

      onClick?.(item)
    }
  }

  function handleClearTemplate() {
    return setFieldValue(commentFieldName, EMPTY_STRING)
  }

  function handleApplyAIText(generatedText, currentValue, action) {
    return applyAITextToTextareaField({
      action,
      currentValue,
      generatedText,
    })
  }

  const commentField = (
    <FormikField
      clearable
      withoutManualResize
      Component={TextareaOutlineField}
      className={textareaClassName}
      fieldComponentProps={{
        className: styles.field,
      }}
      name={commentFieldName}
      placeholder={t('Request.NoticePlaceholderKey')}
    />
  )

  return (
    <FormFieldsContainer className={containerClassName}>
      <FormikField
        Component={FormFieldSelectNG}
        Select={MessageTemplateSelect}
        apiParams={REQUEST_EDIT_USER_COMMENT_FIELDS_TEMPLATES_PARAMS}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: t('Request.TemplatePlaceholderKey'),
            },
          },
        }}
        name={REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE}
        onChange={handleChangeTemplate}
        onClear={handleClearTemplate}
      />
      {aiLocalContext && aiFeatures?.text_generation ? (
        <AITextGenerationField
          fieldContent={values[commentFieldName]}
          fieldName={commentFieldName}
          hasExistingContent={Boolean(values[commentFieldName])}
          localContext={aiLocalContext}
          type={AITextGenerationType.Email}
          onApplyText={handleApplyAIText}
        >
          {commentField}
        </AITextGenerationField>
      ) : (
        commentField
      )}
    </FormFieldsContainer>
  )
}

export default RequestEditUserCommentFields
